// buildVariantParams assembles the query params for the per-section Layout
// (variant) write + the subsequent form re-GET.
//
// The required params (context / section / slug / locale) are taken from the
// current URL when present, else filled from the authoritative editor config.
// This matters because the CMS can be entered from URLs that DON'T carry the
// full set: the website-management "Edit content" link is
// `…/edit?context=property&slug=X` — no `locale`, no `section`. Reading those
// straight from the URL made the server's resolveVariantWrite reject the very
// first variant switch with 400 INVALID_INPUT (blank locale). Once the operator
// navigates the rail, cmsSwitchURL pushes a URL WITH locale, which is why the
// switch "starts working" after visiting another section.
//
// `section` prefers the live section the rail tracks (the caller passes
// `this.section`); config-fixed values (context/slug/locale) never change for
// the life of an editor instance.
export function buildVariantParams(
  search: string,
  config: { context: string; slug: string; locale: string },
  liveSection: string,
): URLSearchParams {
  const params = new URLSearchParams(search);
  if (!params.get("context")) params.set("context", config.context);
  if (!params.get("locale")) params.set("locale", config.locale);
  if (!params.get("section")) params.set("section", liveSection);
  // slug is only required for property context; homepage/site have none.
  if (config.slug && !params.get("slug")) params.set("slug", config.slug);
  return params;
}
